var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloppy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5556 6H8.22222C6.98889 6 6 7 6 8.22222V23.7778C6 25 6.98889 26 8.22222 26H23.7778C25 26 26 25 26 23.7778V10.4444L21.5556 6ZM23.7778 23.7778H8.22222V8.22222H20.6333L23.7778 11.3667V23.7778ZM16 16C14.1556 16 12.6667 17.4889 12.6667 19.3333C12.6667 21.1778 14.1556 22.6667 16 22.6667C17.8444 22.6667 19.3333 21.1778 19.3333 19.3333C19.3333 17.4889 17.8444 16 16 16ZM9.33333 9.33333H19.3333V13.7778H9.33333V9.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppy);
export default __webpack_public_path__ + "static/media/floppy.a8668aeab04a375b2a5c0f73fc6b182f.svg";
export { ForwardRef as ReactComponent };